import * as React from "react";
var SvgIconLarge = function SvgIconLarge(props) {
  return /*#__PURE__*/React.createElement("svg", props);
};
export default SvgIconLarge;